module.exports = __webpack_public_path__ + "img/top-bg.23faacfb.png";